// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.center-cell {
  text-align: center; /* Center the text within the cell */
  vertical-align: middle; /* Center vertically within the cell */
}

.overall-plan-complete {
  display: flex; 
  flex-direction: column; /* Align items in a column */
  align-items: center;  /* Center the items horizontally */
}

.plan-count {
  font-size: 50px;   /* Customize the font size as needed */
  font-weight: bold; /* Make it bold for emphasis */
}
.positive-change {
  color: green; /* Green for positive or no change */
}

.negative-change {
  color: red; /* Red for negative change */
}

.overall-plan-statuses {
  text-align: center; /* Center the title and total label */
}
.custom-tooltip {
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
}

.total-label {
  font-size: 18px; 
  margin-top: 10px; /* Adjust spacing as needed */
}
.total-value {
  font-weight: bold;
}
.recharts-legend-item {
  margin-bottom: 10px;
}

th, td {
  padding: 1em;
  border-radius: 1em;
  background: #fff;
  border-bottom: 2px solid black; 
}

.leaflet-popup-content-wrapper {
  z-index: 1000; /* Set a higher z-index */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;EACxD,sBAAsB,EAAE,sCAAsC;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,mBAAmB,GAAG,kCAAkC;AAC1D;;AAEA;EACE,eAAe,IAAI,sCAAsC;EACzD,iBAAiB,EAAE,8BAA8B;AACnD;AACA;EACE,YAAY,EAAE,oCAAoC;AACpD;;AAEA;EACE,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,kBAAkB,EAAE,qCAAqC;AAC3D;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,6BAA6B;AACjD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,yBAAyB;AAC1C","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.center-cell {\n  text-align: center; /* Center the text within the cell */\n  vertical-align: middle; /* Center vertically within the cell */\n}\n\n.overall-plan-complete {\n  display: flex; \n  flex-direction: column; /* Align items in a column */\n  align-items: center;  /* Center the items horizontally */\n}\n\n.plan-count {\n  font-size: 50px;   /* Customize the font size as needed */\n  font-weight: bold; /* Make it bold for emphasis */\n}\n.positive-change {\n  color: green; /* Green for positive or no change */\n}\n\n.negative-change {\n  color: red; /* Red for negative change */\n}\n\n.overall-plan-statuses {\n  text-align: center; /* Center the title and total label */\n}\n.custom-tooltip {\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.total-label {\n  font-size: 18px; \n  margin-top: 10px; /* Adjust spacing as needed */\n}\n.total-value {\n  font-weight: bold;\n}\n.recharts-legend-item {\n  margin-bottom: 10px;\n}\n\nth, td {\n  padding: 1em;\n  border-radius: 1em;\n  background: #fff;\n  border-bottom: 2px solid black; \n}\n\n.leaflet-popup-content-wrapper {\n  z-index: 1000; /* Set a higher z-index */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
